import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/knowledge/')({
  component: lazyRouteComponent(() => import('@/pages/knowledge/page'), 'KnowledgePage'),
  validateSearch: (search: Record<string, unknown>) => {
    const tab = search.tab
    return {
      tab:
        tab === 'documents' || tab === 'agent-insights' || tab === 'knowledge-graph'
          ? tab
          : undefined,
    }
  },
})
